import "./App.css";
import React from "react";
import "./App.css";
import Rutas from "./components/Rutas/Rutas";

function App() {



  return (
    <>
      <Rutas/>     

      
    </>
  );
}
export default App;
